import React from 'react';
import { getTypeFromModule } from '../Util/Module';
import classnames from 'classnames';
import Link from '../Util/Paths';
import { withRouter } from 'react-router-dom';
import iconCross from '../../../../Public/Icons/Icon-cross.svg';
import iconInfo from '../../../../Public/Icons/info.svg';

class Module extends React.Component {
  moveIcon() {
    if (this.props.moveIcon) {
      return <img className="icon mr-3" src={iconCross} />;
    }
  }

  infoIcon() {
    if (!this.props.selected) {
      return (
        <Link
          to="info"
          params={{
            studyplan: this.props.match.params.studyplan,
            module: this.props.module.uid,
          }}
          className="ml-auto"
        >
          <img className="icon" src={iconInfo} />
        </Link>
      );
    }
  }

  render() {
    const { module } = this.props;
    const [, type] = getTypeFromModule(module);
    const color = type.color;

    return (
      <div
        className={classnames('module d-flex', {
          inactive: this.props.inactive,
        })}
        style={{ backgroundColor: color }}
      >
        {this.moveIcon()}
        {module.name}
        {this.infoIcon()}
      </div>
    );
  }
}
export default withRouter(Module);
